import React from 'react';
import CriteriaList from 'components/VideoResponse/Grading/CriteriaList';
import RatingOptions from 'constants/rating-options';
import PreserveFormatting from 'components/shared/PreserveFormatting';
import RatingScale from 'ui/RatingScale';

const PartnerFeedbackReportDesktop = ({ feedbacks }) => {
  const FeedbackRows = () => {
    return feedbacks.map(feedback => {
      const criteria = {
        id: feedback.id,
        criteriaRatings: feedback.partnerFeedback.criteria,
        ratingOptions: RatingOptions,
        preview: true,
      };

      return (
        <tr key={feedback.id} className="ReportCard-row">
          <td className="ReportCard-rowNumber" />
          <td className="ReportCard-divider" />
          <td>
            <PreserveFormatting>{feedback.scenario}</PreserveFormatting>
          </td>
          <td>
            <PreserveFormatting>{feedback.goal}</PreserveFormatting>
          </td>
          <td>
            <CriteriaList data={criteria} />
            <div className="fw-b">
              {t('progress.report_card.role_play.overall')}:
            </div>
            <RatingScale
              ratingOptions={RatingOptions}
              score={feedback.partnerFeedback.overallScore}
              customClassName="mb-16 d-f fw-w"
              preview
            />
            <div className="fw-b">{t('grades.feedback.comments')}:</div>
            <PreserveFormatting>
              {feedback.partnerFeedback.feedback}
            </PreserveFormatting>
          </td>
          <td>{feedback.partnerFeedback.partner}</td>
        </tr>
      );
    });
  };

  return (
    <table className="ReportCard scored">
      <thead>
        <tr>
          <th className="ReportCard-rowNumber" />
          <th className="ReportCard-divider" />
          <th>{t('progress.report_card.role_play.scenario')}</th>
          <th>{t('progress.report_card.role_play.goal')}</th>
          <th>{t('progress.report_card.role_play.partner.feedback')}</th>
          <th>{t('progress.report_card.role_play.partner.title')}</th>
        </tr>
      </thead>
      <tbody>
        <FeedbackRows />
      </tbody>
    </table>
  );
};

export default PartnerFeedbackReportDesktop;
